<video
  data-test-id="preview-video"
  class="preview-video"
  [ngClass]="{ 'preview-border': hasBorder }"
  autoplay
  #previewVideo
></video>
